module.exports = __webpack_public_path__ + "static/img/tag-flag.2f133716.svg";